import { render, staticRenderFns } from "./SinglechoiceModule.vue?vue&type=template&id=5d850976&scoped=true&"
import script from "./SinglechoiceModule.vue?vue&type=script&lang=js&"
export * from "./SinglechoiceModule.vue?vue&type=script&lang=js&"
import style0 from "./SinglechoiceModule.vue?vue&type=style&index=0&id=5d850976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d850976",
  null
  
)

export default component.exports